export const FETCH_STATES = 'FETCH_STATES'
export const FETCH_STATES_SUCCESS = 'FETCH_STATES_SUCCESS'

export const FETCH_CITIES = 'FETCH_CITIES'
export const FETCH_CITIES_SUCCESS = 'FETCH_CITIES_SUCCESS'
